/* eslint-disable react-refresh/only-export-components */
import React from "react";

export const Slot = React.forwardRef<HTMLElement, React.HTMLAttributes<HTMLElement>>(({ children, ...props }, ref) => {
  if (React.isValidElement(children)) {
    return React.cloneElement(children, { ...props, ref } as React.HTMLAttributes<HTMLElement>);
  }
  return (
    <span ref={ref as React.Ref<HTMLSpanElement>} {...props}>
      {children}
    </span>
  );
});
Slot.displayName = "Slot";

export function createSlot(ownerName?: string) {
  const CreatedSlot = React.forwardRef<HTMLElement, React.HTMLAttributes<HTMLElement>>((props, ref) => <Slot ref={ref} {...props} />);

  CreatedSlot.displayName = ownerName ?? Slot.displayName;

  return CreatedSlot;
}
